import * as myaTrackingBct from '@otto-ec/tracking-bct'

class MyAccountTracking {
    public static sendEventToTrackingServer(event: SimpleDataContainer) {
        myaTrackingBct.submitEvent(MyAccountTracking._toDataContainer(event))
    }

    public static sendMergeToTrackingServer(event: SimpleDataContainer) {
        myaTrackingBct.submitMerge(MyAccountTracking._toDataContainer(event))
    }

    public static trackOnNextPageImpression(event: SimpleDataContainer) {
        myaTrackingBct.trackOnNextPageImpression(MyAccountTracking._toDataContainer(event))
    }

    public static sendMoveEventToTrackingServer(event: SimpleDataContainer) {
        myaTrackingBct.submitMove(MyAccountTracking._toDataContainer(event))
    }

    private static _toDataContainer(event: SimpleDataContainer): myaTrackingBct.DataContainer {
        const dataContainer: myaTrackingBct.DataContainer = {}
        Object.keys(event).forEach(key => {
            const value = event[key]
            if (value) {
                dataContainer[key] = [value]
            }
        })
        return dataContainer
    }
}

type SimpleDataContainer = Record<string, string | undefined>;

export {MyAccountTracking, SimpleDataContainer}